import { useEffect, useState } from "react";
import { ShieldAlert, RefreshCw } from "lucide-react";
import { api, fmtDate } from "@/lib/api";

const KINDS = { screenshot: "സ്ക്രീൻഷോട്ട്", screen_record: "സ്ക്രീൻ റെക്കോർഡ്", multi_touch: "മൾട്ടി-ടച്ച്", privacy_violation: "Privacy Violation", app_hidden: "ആപ്പ് മറച്ചു", devtools: "DevTools", print: "പ്രിന്റ്" };

export const SecurityAlerts = () => {
  const [sum, setSum] = useState(null);
  const [events, setEvents] = useState([]);
  const [userId, setUserId] = useState("");
  const [kind, setKind] = useState("");

  const load = () => {
    api.get("/admin/security-events/summary").then((r) => setSum(r.data)).catch(() => null);
    api.get("/admin/security-events", { params: { user_id: userId || undefined, kind: kind || undefined, limit: 100 } }).then((r) => setEvents(r.data)).catch(() => null);
  };
  useEffect(() => { load(); const t = setInterval(load, 15000); return () => clearInterval(t); }, [userId, kind]); // eslint-disable-line

  return (
    <div data-testid="security-alerts" className="card rounded-2xl p-5 space-y-4">
      <div className="flex flex-wrap items-center gap-3">
        <span className="w-10 h-10 rounded-xl bg-red-50 text-red-500 inline-flex items-center justify-center"><ShieldAlert size={18} /></span>
        <div className="flex-1 min-w-[160px]"><p className="label-caps">Security Alert Log</p><p className="text-xs text-[var(--muted-text)]">സ്ക്രീൻഷോട്ട് / റെക്കോർഡിംഗ് ഇവന്റുകൾ (ബ്രൗസർ കണ്ടെത്തിയത്)</p></div>
        <div className="flex gap-2">
          <span data-testid="security-count-1h" className={`rounded-full px-3 h-8 inline-flex items-center text-xs font-bold ${sum?.total_1h ? "bg-red-50 text-red-600 glow-pulse" : "bg-slate-50 text-slate-500"}`}>1h: {sum?.total_1h ?? 0}</span>
          <span data-testid="security-count-24h" className="rounded-full px-3 h-8 inline-flex items-center text-xs font-bold bg-amber-50 text-amber-700">24h: {sum?.total_24h ?? 0}</span>
          <span data-testid="security-count-total" className="rounded-full px-3 h-8 inline-flex items-center text-xs font-bold bg-slate-50 text-slate-600">ആകെ: {sum?.total ?? 0}</span>
          <button data-testid="security-refresh" onClick={load} className="btn-ghost w-8 h-8 rounded-full inline-flex items-center justify-center"><RefreshCw size={13} /></button>
        </div>
      </div>
      <div className="flex flex-wrap gap-2">
        <select data-testid="security-user-filter" value={userId} onChange={(e) => setUserId(e.target.value)} className="h-9 rounded-xl border border-[var(--line)] bg-white px-3 text-xs">
          <option value="">എല്ലാ യൂസർമാരും</option>
          {(sum?.users || []).map((u) => <option key={u.user_id} value={u.user_id}>{u.name} ({u.role}) · {u.count}</option>)}
        </select>
        <select data-testid="security-kind-filter" value={kind} onChange={(e) => setKind(e.target.value)} className="h-9 rounded-xl border border-[var(--line)] bg-white px-3 text-xs">
          <option value="">എല്ലാ തരവും</option>
          {Object.entries(KINDS).map(([k, l]) => <option key={k} value={k}>{l} {sum?.by_kind_24h?.[k] ? `(${sum.by_kind_24h[k]})` : ""}</option>)}
        </select>
      </div>
      <div data-testid="security-events-list" className="divide-y divide-[var(--line)] max-h-72 overflow-auto rounded-xl border border-[var(--line)]">
        {events.length === 0 && <p className="p-4 text-xs text-[var(--muted-text)] text-center">ഇവന്റുകൾ ഇല്ല</p>}
        {events.map((e) => (
          <div key={e.id} data-testid={`security-event-${e.id}`} className="px-3 py-2 flex items-center gap-3 text-xs">
            <span className={`rounded-full px-2 py-0.5 font-bold ${["screenshot", "screen_record", "privacy_violation", "multi_touch"].includes(e.kind) ? "bg-red-50 text-red-600" : "bg-amber-50 text-amber-700"}`}>{KINDS[e.kind] || e.kind}</span>
            <button type="button" onClick={() => setUserId(e.user_id)} className="font-semibold hover:underline">{e.user_name}</button>
            <span className="text-[10px] text-[var(--muted-text)]">{e.role}{e.context ? ` · ${e.context}` : ""}</span>
            <span className="ml-auto font-num text-[10px] text-[var(--muted-text)]">{fmtDate(e.created_at)}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
